document.querySelectorAll('.yrp-sneaker-mega').forEach(function(menu){
  if(menu.dataset.megaBound)return;
  menu.dataset.megaBound='true';
  var summary=menu.querySelector(':scope > summary');
  var timer;
  var pointer=window.matchMedia('(hover:hover) and (min-width:1200px)');
  var close=function(){menu.open=false;summary.setAttribute('aria-expanded','false');};
  var open=function(){clearTimeout(timer);var header=menu.closest('.yrp-banner-header,.header');if(header)header.querySelectorAll('.yrp-header-search[open]').forEach(function(search){search.open=false;});menu.open=true;summary.setAttribute('aria-expanded','true');};
  menu.addEventListener('mouseenter',function(){if(pointer.matches)open();});
  menu.addEventListener('mouseleave',function(){if(pointer.matches){clearTimeout(timer);timer=setTimeout(close,160);}});
  menu.addEventListener('focusin',open);
  menu.addEventListener('focusout',function(event){if(!menu.contains(event.relatedTarget))close();});
  menu.addEventListener('keydown',function(event){if(event.key==='Escape'){clearTimeout(timer);close();summary.focus();menu.open=false;}});
  menu.addEventListener('toggle',function(){summary.setAttribute('aria-expanded',String(menu.open));});
  document.addEventListener('click',function(event){if(!menu.contains(event.target))close();});
  pointer.addEventListener('change',close);
});
